export interface QuickBooksFieldMappingRowConstructor {
  group: string // equals `name` for flat (ungrouped) fields
  name: string
  internalObjectKey: Nullable<string> // linked Procurify default field key
  customFieldId: Nullable<number> // linked Procurify custom field id
  customFieldName: Nullable<string> // resolved custom field name, e.g. "Cost Center"
}

export class QuickBooksFieldMappingRow {
  readonly group: string
  readonly name: string
  readonly internalObjectKey: Nullable<string>
  readonly customFieldId: Nullable<number>
  readonly customFieldName: Nullable<string>

  constructor(data: QuickBooksFieldMappingRowConstructor) {
    this.group = data.group
    this.name = data.name
    this.internalObjectKey = data.internalObjectKey
    this.customFieldId = data.customFieldId
    this.customFieldName = data.customFieldName
  }

  // A custom-field link counts even when its field is no longer active and
  // its name cannot be resolved, so the stale link can still be unlinked.
  get isLinked(): boolean {
    return this.internalObjectKey !== null || this.customFieldId !== null
  }

  // "QuickBooks Field" column: `group-name` when grouped, bare `name`
  // when flat (BHV-010).
  get quickBooksFieldLabel(): string {
    return this.group === this.name ? this.name : `${this.group}-${this.name}`
  }

  // "Procurify Field" column: default key, resolved custom field name, or
  // empty when unlinked (BHV-010).
  get procurifyFieldLabel(): Nullable<string> {
    return this.internalObjectKey ?? this.customFieldName
  }
}
